
import React from 'react';
import { Textarea } from "@/components/ui/textarea";
import { Input } from "@/components/ui/input";
import { Card, CardContent, CardDescription, CardFooter, CardHeader, CardTitle } from "@/components/ui/card";
import { Label } from "@/components/ui/label";
import { Button } from "@/components/ui/button";
import { Loader2, ArrowLeft } from "lucide-react";

interface UserProfileInputProps {
  profileTitle: string;
  profileOverview: string;
  onProfileTitleChange: (value: string) => void;
  onProfileOverviewChange: (value: string) => void;
  onSubmit: () => void;
  onBack: () => void;
  isLoading: boolean;
}

const UserProfileInput: React.FC<UserProfileInputProps> = ({
  profileTitle,
  profileOverview,
  onProfileTitleChange,
  onProfileOverviewChange,
  onSubmit,
  onBack,
  isLoading,
}) => {
  return (
    <Card>
      <CardHeader>
        <CardTitle>Your Upwork Profile</CardTitle>
        <CardDescription>
          Before crafting the proposal, please share your Upwork profile details to tailor the proposal to your expertise.
        </CardDescription>
      </CardHeader>
      <CardContent>
        <div className="space-y-4">
          <div className="space-y-2">
            <Label htmlFor="profileTitle">Upwork Profile Title</Label>
            <Input
              id="profileTitle"
              placeholder="e.g., Technical Product Manager | Product Owner"
              value={profileTitle}
              onChange={(e) => onProfileTitleChange(e.target.value)}
              className="bg-slate-100 dark:bg-slate-800"
            />
          </div>
          
          <div className="space-y-2">
            <Label htmlFor="profileOverview">Brief Overview of Your Experience</Label>
            <Textarea
              id="profileOverview"
              placeholder="Briefly describe your professional background, key skills, and notable projects with specific metrics and outcomes"
              className="min-h-[150px] bg-slate-100 dark:bg-slate-800"
              value={profileOverview}
              onChange={(e) => onProfileOverviewChange(e.target.value)}
            />
          </div>
        </div>
      </CardContent>
      <CardFooter className="flex justify-between">
        <Button 
          variant="outline" 
          onClick={onBack}
          className="gap-2"
        >
          <ArrowLeft size={16} /> Back
        </Button>
        <Button 
          onClick={onSubmit} 
          disabled={isLoading}
        >
          {isLoading ? (
            <>
              <Loader2 className="mr-2 h-4 w-4 animate-spin" />
              Generating Proposal...
            </>
          ) : (
            "Generate Winning Proposal"
          )}
        </Button>
      </CardFooter>
    </Card>
  );
};

export default UserProfileInput;
